module.exports = __webpack_public_path__ + "img/portfolio-square.808c5524.jpg";